export const whiteListUsers = [
  'qpIlIpp',
  'kyurkov',
  'adutova99',
  'Alexey',
  'adurakov',
  'savinova.v',
  'kotlov.m',
  'ponomareva.k',
  'gladkov.m',
  'mzamanov',
  'kuznetsova.s',
  'm.klishin',
  'chernyshova.s',
  'burin.n',
  'arlanova.a',
  'belyakov.k',
  'dyshlevsky.k',
].map((s) => s.toLowerCase());
